var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeciality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #707070;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #0071f2;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44525",
    "data-name": "Rectangle 44525",
    className: "cls-1",
    width: 12,
    height: 12,
    transform: "translate(688 168)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_33",
    "data-name": "Mask Group 33",
    className: "cls-2",
    transform: "translate(-688 -168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-stethoscope",
    className: "cls-3",
    d: "M2.9,1.7A1.2,1.2,0,0,0,1.7,2.9V4.7A4.2,4.2,0,0,0,4.345,8.592a1.792,1.792,0,0,0,.955.8V11.3a2.4,2.4,0,0,0,2.4,2.4h2.4a2.4,2.4,0,0,0,2.4-2.4v-.11a1.8,1.8,0,1,0-1.2,0v.11a1.2,1.2,0,0,1-1.2,1.2H7.7a1.2,1.2,0,0,1-1.2-1.2V9.39a1.792,1.792,0,0,0,.955-.8,4.205,4.205,0,0,0,2.645-3.9V2.9A1.2,1.2,0,0,0,8.9,1.7H7.7V2.9H8.9V4.7a3,3,0,0,1-6-.014V2.9H4.1V1.7Zm9,7.05a.75.75,0,1,1-.75.75A.75.75,0,0,1,11.9,8.75Z",
    transform: "translate(686.3 166.3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality);
export default __webpack_public_path__ + "static/media/speciality.382598f7f0e66c4a63bcfbd09ec2e3bb.svg";
export { ForwardRef as ReactComponent };